import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';
import type { TvShow } from '@/mocks/tvshows';

type MediaItem = Movie | TvShow;

interface MediaCardProps {
  item: MediaItem;
  className?: string;
}

export default function MediaCard({ item, className = '' }: MediaCardProps) {
  const isTv = item.type === 'tv';

  return (
    <Link
      to={`/detail/${item.id}`}
      className={`group block ${className}`}
      aria-label={`${item.title} 详情`}
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden rounded-lg bg-secondary-100">
        <img
          src={item.poster}
          alt={`${item.title} 影视海报`}
          title={`${item.title} - 在线观看 - 神马影视`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <span className="absolute top-2 right-2 inline-flex items-center gap-1 rounded-md bg-accent-500 px-1.5 py-0.5 text-xs font-label font-bold text-foreground-950">
          <i className="ri-star-fill" />
          {item.rating.toFixed(1)}
        </span>
        {isTv && (
          <span className="absolute top-2 left-2 rounded-md bg-primary-500/95 px-1.5 py-0.5 text-xs font-label font-medium text-background-50">
            {(item as TvShow).status}
          </span>
        )}
        <span className="absolute inset-x-0 bottom-0 flex items-center justify-center pb-4 translate-y-3 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
          <span className="inline-flex items-center gap-1 rounded-full bg-accent-500 px-3 py-1.5 text-xs font-label font-semibold text-foreground-950">
            <i className="ri-play-fill" />
            立即观看
          </span>
        </span>
      </div>
      <h3 className="mt-2 text-sm font-medium text-foreground-950 line-clamp-1 group-hover:text-primary-600 transition-colors">
        {item.title}
      </h3>
      <p className="mt-0.5 text-xs text-foreground-600 flex items-center gap-1.5">
        <span className="font-label">{item.year}</span>
        <span className="text-background-300">·</span>
        <span className="line-clamp-1">{item.genres.slice(0, 2).join(' / ')}</span>
      </p>
    </Link>
  );
}